import { withInstall } from '@/utils'
import CosApiSelect from './src/index.vue'
export default withInstall(CosApiSelect)
